import React, {useEffect, useState} from 'react';
import {SoopUiSwiper} from '@/components/ui';
import MyCatch from '@/components/my/common/item/MyCatch';
import {CATCH_CONTEXT_MENU, SELECTED_MODE} from '@/constants/main';
import {isLogin} from '@/utils/main';
import useListViewLog from '@/components/main/MyPlus/hooks/useListViewLog';
import {useHiddenStreamer} from '@/components/main/common/hooks/useHiddenStreamer';

const swiperConfig = {
  loop: false,
  spaceBetween: 20,
};

const CatchDefaultTemplate = ({itemList, selectedMode, log = {}}) => {
  const {startObserve, endObserve} = useListViewLog(
    {
      path1: !isLogin()
        ? 'popular'
        : selectedMode === 'popular'
          ? selectedMode
          : 'myplus',
      path2: 'catch',
      listType: 'CATCH',
      selector: '.catch_area',
    },
    itemList,
  );

  const {
    hiddenStreamerList,
    handleOnClickHiddenStreamer,
    handleOnClickUndoHiddenStreamer,
  } = useHiddenStreamer('VOD', 'myplus');

  const handleOnClickMenu = (e, type, data) => {
    if (type === 'hidden') {
      handleOnClickHiddenStreamer(data);
    }
  };

  const handleUndoBroadcast = (data) => {
    if (hiddenStreamerList.includes(data.broadcastId)) {
      handleOnClickUndoHiddenStreamer(data);
    }
  };

  /** 로그 활성화 */
  useEffect(() => {
    startObserve();
    return () => endObserve();
  }, [itemList, selectedMode]);

  return (
    <div className='catch_area'>
      <SoopUiSwiper
        swiperClass='catch_list'
        swiperTag='ul'
        maxSlidesPerView={10}
        otherMaxSlidesResolution={[
          {max: 1623, slidePerView: 10},
          {max: 1202, slidePerView: 8},
          {max: 1000, slidePerView: 6},
          {max: 751, slidePerView: 5},
          {max: 496, slidePerView: 4},
          {max: 0, slidePerView: 3},
        ]}
        options={swiperConfig}>
        {itemList.map((item, idx) => (
          <li key={idx}>
            <MyCatch
              {...{
                ...item,
                isAdult: Number(item.grade) === 19,
                catchContextMenuList: CATCH_CONTEXT_MENU,
              }}
              thumbnailSrc={item.thumbnailSrc}
              isLogSendData={
                selectedMode === SELECTED_MODE.PREFER
                  ? {listIdx: idx + 1, ...log}
                  : {exCategoryNo: item.vodCategory, ...log}
              }
              hiddenStreamerList={hiddenStreamerList}
              handleUndoBroadcast={handleUndoBroadcast}
              handleMenuClicked={handleOnClickMenu}
            />
          </li>
        ))}
      </SoopUiSwiper>
    </div>
  );
};

export default CatchDefaultTemplate;
